const typeNamespace = 'MODAL_';

export const DELETE_MODAL_OPEN = `${typeNamespace}DELETE_OPEN`;
export const DELETE_MODAL_CLOSE = `${typeNamespace}DELETE_CLOSE`;

export const STORY_READING_MODAL_OPEN = `${typeNamespace}STORY_READING_MODAL_OPEN`;
export const STORY_READING_MODAL_CLOSE = `${typeNamespace}STORY_READING_MODAL_CLOSE`;

export const STORY_DETAIL_MODAL_OPEN = `${typeNamespace}STORY_DETAIL_MODAL_OPEN`;
export const STORY_DETAIL_MODAL_CLOSE = `${typeNamespace}STORY_DETAIL_MODAL_CLOSE`;

export const STUDENT_DETAIL_MODAL_OPEN = `${typeNamespace}STUDENT_DETAIL_MODAL_OPEN`;
export const STUDENT_DETAIL_MODAL_CLOSE = `${typeNamespace}STUDENT_DETAIL_MODAL_CLOSE`;

export const QUESTION_DETAIL_MODAL_OPEN = `${typeNamespace}QUESTION_DETAIL_MODAL_OPEN`;
export const QUESTION_DETAIL_MODAL_CLOSE = `${typeNamespace}QUESTION_DETAIL_MODAL_CLOSE`;